export default "__VITE_ASSET__duV5nh1e__"